import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SITE_URL } from "@/lib/seo";

/**
 * Breadcrumb visible + accessible. Les items sont { name, path } (path relatif,
 * ex: "/services/demenagement"). Le dernier item est la page courante (non
 * cliquable). Le JSON-LD BreadcrumbList correspondant est émis séparément via
 * <Seo jsonLd={buildBreadcrumbLd(...)} /> avec des URLs absolues identiques.
 */
export default function Breadcrumbs({ items = [], variant = "light" }) {
  if (!items.length) return null;
  const muted = variant === "dark" ? "text-white/70" : "text-[#6B7280]";
  const hover = variant === "dark" ? "hover:text-white" : "hover:text-[#2D5BFF]";
  const current = variant === "dark" ? "text-[#FFD84D]" : "text-[#0A0F2C]";
  return (
    <nav aria-label="breadcrumb" data-testid="breadcrumbs" className={`text-xs md:text-sm ${muted}`}>
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.path || it.name} className="inline-flex items-center gap-1">
              {last || !it.path ? (
                <span className={`font-semibold ${current}`} aria-current="page">{it.name}</span>
              ) : (
                <Link to={it.path} className={`${hover} transition-colors`}>{it.name}</Link>
              )}
              {!last && <ChevronRight size={13} className="opacity-60" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

// Helper: transforme des items { name, path } en items JSON-LD { name, url absolu }.
export function toLdItems(items) {
  return items.map((it) => ({ name: it.name, url: it.path ? `${SITE_URL}${it.path}` : SITE_URL }));
}
